<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 8V7a3 3 0 0 1 3-3h1M4 16v1a3 3 0 0 0 3 3h1m8-16h1a3 3 0 0 1 3 3v1m0 8v1a3 3 0 0 1-3 3h-1"
      stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    />
    <path
      d="M12.185 9.29a.5.5 0 0 0 .223-.224l.645-1.29a.5.5 0 0 1 .894 0l.645 1.29a.5.5 0 0 0 .224.224l1.29.645a.5.5 0 0 1 0 .894l-1.29.645a.5.5 0 0 0-.224.224l-.645 1.29a.5.5 0 0 1-.894 0l-.645-1.29a.5.5 0 0 0-.223-.224l-1.29-.645a.5.5 0 0 1 0-.894zm-3.607 4.303a.3.3 0 0 0 .134-.134l.52-1.04a.3.3 0 0 1 .537 0l.52 1.04a.3.3 0 0 0 .134.134l1.04.52a.3.3 0 0 1 0 .537l-1.04.52a.3.3 0 0 0-.134.135l-.52 1.04a.3.3 0 0 1-.537 0l-.52-1.04a.3.3 0 0 0-.134-.134l-1.041-.52a.3.3 0 0 1 0-.537z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
